/**
 * State for forgot password
 */
export const state = {
  /**
   * The user id who has forgotten the password
   */
  userId: 0,

  /**
   * The token related to the questions
   */
  token: false,

  /**
   * The question which the user wants to answer
   */
  question: "",

  /**
   * Weater the email entered is wrong,
   */
  wrongEmail: false,

  /**
   * Insurance questions
   * Format
   * {
   *    businessName:"Greater Valley", // This is the name that is to be shown to the user.
   *    insuranceCoID:2833,
   *    shortName:"Greater Valley"
   * }[2] // Always two options are present
   */
  insuranceQuestions: [],

  /**
   * Reset token for the password
   */
  resetToken: false,

  /**
   * Weather reset token is verified
   */
  resetTokenVerified: 0
};
